// extracted by mini-css-extract-plugin
module.exports = {"genericToggle":"GenericToggle_genericToggle__1hTQz"};